import { ForbiddenError } from "@/features/errors/forbidden";

export const Route = createFileRoute({
  component: ForbiddenError,
});
